import actionTypes from '../actions/reduxActions/actionTypes';

/**
 * mapElements don't include their containing flow id
 * This stores a map of { mapElementId: flowId }
 */

const mapElementIdFlowId = (map = {}, { type, payload }) => {

    switch (type) {

    case actionTypes.MAP_ELEMENT_ID_FLOW_ID_SET: {
        // Add the new mapping between map elements and the flow they're in
        const newMap = {};
        payload.mapElements.forEach((mapElement) => {
            newMap[mapElement.id] = payload.flowId;
        });

        // Re-add all previous entries
        Object.entries(map)
            // except if that entry is for this flow
            .filter(([, value]) => value !== payload.flowId)
            .forEach(([key, value]) => {
                newMap[key] = value;
            });

        return { ...newMap };
    }

    case actionTypes.MAP_ELEMENT_DELETE: {
        const { [payload]: _, ...filtered } = map;
        return filtered;
    }

    default:
        return map;
    }
};

export default mapElementIdFlowId;
